(function ($) {
	$(() => {

		$('.slider-container-1 .slider').slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: '.slider-container-1 .arrow--left',
			nextArrow: '.slider-container-1 .arrow--right',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						dots: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: true
					}
				},
				{
					breakpoint: 500,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]

		});

		$('.slider-container-2 .slider').slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: '.slider-container-2 .arrow--left',
			nextArrow: '.slider-container-2 .arrow--right',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						dots: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: true
					}
				},
				{
					breakpoint: 500,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]

		});

		$('.slider-container-3 .slider').slick({
			infinite: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			arrows: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]

		});

		$('.slider-container-4 .slider').slick({
			infinite: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			arrows: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]

		});

	});
})(jQuery);
